/* ============================================================
   LUXEA PARFUMS — JavaScript global
   Carrito lateral (drawer), menú móvil, acordeón, animaciones,
   utilidades del carrito (AJAX Cart API de Shopify)
   ============================================================ */
(function () {
  'use strict';

  const money = (cents) => {
    const fmt = (window.LuxeaTheme && window.LuxeaTheme.moneyFormat) || '{{amount}} €';
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return fmt.replace(/\{\{\s*amount[_a-z]*\s*\}\}/g, amount);
  };
  window.Luxea = window.Luxea || {};
  window.Luxea.money = money;

  /* ---------- Toast ---------- */
  let toastEl;
  function toast(message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg><span></span>';
      document.body.appendChild(toastEl);
    }
    toastEl.querySelector('span').textContent = message;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), 2800);
  }
  window.Luxea.toast = toast;

  /* ============================================================
     CARRITO (Shopify AJAX Cart API)
     ============================================================ */
  const Cart = {
    async get() {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      return res.json();
    },
    async add(items) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) { const e = await res.json().catch(() => ({})); throw new Error(e.description || 'Error al añadir'); }
      return res.json();
    },
    async change(payload) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });
      return res.json();
    }
  };
  window.Luxea.Cart = Cart;

  /* ---------- Drawer del carrito ---------- */
  const overlay = document.querySelector('[data-drawer-overlay]');
  const drawer = document.querySelector('[data-cart-drawer]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    renderCart();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  window.Luxea.openCart = openDrawer;
  window.Luxea.closeCart = closeDrawer;

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cart-close]') || e.target === overlay) { closeDrawer(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); closeMobileMenu(); } });

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }
  window.Luxea.updateCartCount = updateCartCount;

  function renderCart() {
    const itemsEl = drawer && drawer.querySelector('[data-cart-items]');
    const footEl = drawer && drawer.querySelector('[data-cart-foot]');
    if (!itemsEl) return;
    const EXTRA_HANDLE = 'decant-vacio-con-jeringuilla';
    const MIN_PACK = 3;
    Cart.get().then((cart) => {
      updateCartCount(cart.item_count);
      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<div class="cart-drawer__empty"><p>Tu carrito está vacío.</p><a href="/pages/seleccion-genero-decants" class="btn btn--outline" data-cart-close>Descubrir perfumes</a></div>';
        if (footEl) footEl.style.display = 'none';
        return;
      }
      if (footEl) footEl.style.display = 'block';

      /* Perfumes que cuentan para el descuento y para desbloquear el decant vacío */
      const handles = Array.isArray(window.LuxeaTierHandles) ? window.LuxeaTierHandles : null;
      const perfumeCount = handles
        ? cart.items.reduce((n, it) => n + ((it.handle !== EXTRA_HANDLE && handles.indexOf(it.handle) !== -1) ? it.quantity : 0), 0)
        : 0;
      const hasExtra = cart.items.some((it) => it.handle === EXTRA_HANDLE);
      const extraLocked = !!handles && hasExtra && perfumeCount < MIN_PACK;
      const needed = MIN_PACK - perfumeCount;

      itemsEl.innerHTML = cart.items.map((item, i) => {
        const props = Object.keys(item.properties || {})
          .filter((k) => k[0] !== '_' && item.properties[k])
          .map((k) => `<div class="cart-line__prop">${k}: ${item.properties[k]}</div>`).join('');
        const colorImg = item.properties && item.properties['_img'];
        const img = colorImg ? colorImg : (item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1') : '');
        const isPack = !!(item.properties && item.properties['_pack']);
        const isLocked = extraLocked && item.handle === EXTRA_HANDLE;
        const lockHtml = isLocked
          ? `<div class="cart-line__lock">Para poder coger el decant vacío con jeringuilla debes completar un pack. Añade ${needed} perfume${needed === 1 ? '' : 's'} más.</div>`
          : '';
        const qtyHtml = isPack
          ? `<div class="cart-line__prop">Cantidad: ${item.quantity}</div>`
          : `<div class="cart-line__qty" data-qty>
              <button data-line-minus aria-label="Restar">−</button>
              <span>${item.quantity}</span>
              <button data-line-plus aria-label="Sumar">+</button>
            </div>`;
        return `<div class="cart-line${isLocked ? ' cart-line--locked' : ''}" data-line="${i + 1}">
          <div class="cart-line__img">${img ? `<img src="${img}" alt="${item.product_title}">` : ''}</div>
          <div>
            <div class="cart-line__title">${item.product_title}</div>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-line__variant">${item.variant_title}</div>` : ''}
            ${props}
            ${lockHtml}
            ${qtyHtml}
            <button class="cart-line__remove" data-line-remove>Eliminar</button>
          </div>
          <div class="cart-line__price">${money(item.final_line_price)}</div>
        </div>`;
      }).join('');

      /* Subtotal (con el original tachado si hay descuento) */
      const subEl = drawer.querySelector('[data-cart-subtotal]');
      if (subEl) subEl.textContent = money(cart.items_subtotal_price);
      const origEl = drawer.querySelector('[data-cart-subtotal-original]');
      if (origEl) {
        const hasDiscount = cart.original_total_price > cart.items_subtotal_price;
        origEl.style.display = hasDiscount ? '' : 'none';
        origEl.textContent = hasDiscount ? money(cart.original_total_price) : '';
      }

      /* Aviso de descuento por cantidad */
      const promoEl = drawer.querySelector('[data-cart-promo]');
      if (promoEl && handles) {
        let msg = '';
        if (perfumeCount >= 5) msg = '¡Se está aplicando un 20% de descuento!';
        else if (perfumeCount >= 3) msg = 'Se está aplicando un 15% de descuento. Añade ' + (5 - perfumeCount) + ' más para llegar al 20%';
        else if (perfumeCount >= 1) msg = 'Añade ' + (3 - perfumeCount) + ' más y llévate un 15% de descuento';
        promoEl.style.display = msg ? '' : 'none';
        if (msg) {
          promoEl.querySelector('[data-cart-promo-text]').textContent = msg;
          promoEl.querySelector('[data-cart-promo-bar]').style.width = (Math.min(perfumeCount / 5, 1) * 100) + '%';
        }
      }

      /* Botón de finalizar: desactivado si el decant vacío está sin desbloquear */
      const checkoutBtn = footEl && footEl.querySelector('[name="checkout"]');
      if (checkoutBtn) {
        checkoutBtn.disabled = extraLocked;
        checkoutBtn.style.opacity = extraLocked ? '0.5' : '';
        checkoutBtn.style.cursor = extraLocked ? 'not-allowed' : '';
        checkoutBtn.textContent = extraLocked ? 'Completa un pack para continuar' : 'Finalizar compra';
      }
    });
  }
  window.Luxea.renderCart = renderCart;

  if (drawer) {
    drawer.addEventListener('click', async (e) => {
      const line = e.target.closest('[data-line]');
      if (!line) return;
      const idx = parseInt(line.getAttribute('data-line'), 10);
      const span = line.querySelector('[data-qty] span');
      const current = span ? parseInt(span.textContent, 10) : 0;
      if (e.target.closest('[data-line-plus]')) { await Cart.change({ line: idx, quantity: current + 1 }); renderCart(); }
      else if (e.target.closest('[data-line-minus]')) { await Cart.change({ line: idx, quantity: Math.max(0, current - 1) }); renderCart(); }
      else if (e.target.closest('[data-line-remove]')) { await Cart.change({ line: idx, quantity: 0 }); renderCart(); }
    });
  }

  /* ---------- Añadir al carrito (formularios product / botones) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const id = form.querySelector('[name="id"]').value;
    const qtyField = form.querySelector('[name="quantity"]');
    const quantity = qtyField ? parseInt(qtyField.value, 10) || 1 : 1;
    const properties = {};
    form.querySelectorAll('[name^="properties["]').forEach((p) => {
      const key = p.name.match(/\[(.+)\]/)[1];
      if (p.value) properties[key] = p.value;
    });
    const original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = '<span class="spinner"></span>'; }
    try {
      await Cart.add([{ id, quantity, properties }]);
      toast('Añadido al carrito');
      openDrawer();
    } catch (err) {
      toast(err.message || 'No se pudo añadir');
    } finally {
      if (btn) { btn.disabled = false; btn.innerHTML = original; }
    }
  });

  /* ============================================================
     MENÚ MÓVIL
     ============================================================ */
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  function closeMobileMenu() { if (mobileMenu) { mobileMenu.classList.remove('is-open'); document.body.style.overflow = ''; } }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-menu-open]')) { mobileMenu && mobileMenu.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    if (e.target.closest('[data-menu-close]')) { closeMobileMenu(); }
  });

  /* ============================================================
     ACORDEÓN (FAQ)
     ============================================================ */
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger) return;
    const item = trigger.closest('.accordion__item');
    const panel = item.querySelector('.accordion__panel');
    const isOpen = item.classList.toggle('is-open');
    panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0';
  });

  /* ============================================================
     CABECERA AL HACER SCROLL
     ============================================================ */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 12);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ============================================================
     ANIMACIONES REVEAL AL HACER SCROLL
     ============================================================ */
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }

  /* ---------- Sincronizar contador al cargar ---------- */
  Cart.get().then((c) => updateCartCount(c.item_count)).catch(() => {});
})();